import React, { createContext, useContext, useState } from 'react'; 
import MonthView from './monthView';
import WeekView from './weekView';
import YearView from './yearView';
import DayView from './dayView';

// Create Context for Calendar Views
const CalendarViewsContext = createContext();


export const CalendarViewsProvider = ({ children }) => {
    const [view, setView] = useState('day'); 
    return (
        <CalendarViewsContext.Provider value={{ MonthView, DayView, WeekView, YearView, view, setView }}>
            {children}
        </CalendarViewsContext.Provider>
    );
};

// Custom hook to access Calendar Views Context
export const useCalendarViews = () => useContext(CalendarViewsContext);

